import Blockly from 'blockly'
import 'blockly/python'

let blockJson = {
  type: 'machine_ifline_mortor_ir_reset',
  message0: '%{BKY_CUSTOM_MACHINE_IFLINE_MORTOR_IR_RESET}',
  args0: [
    {
      type: 'field_image',
      src: 'https://i.ibb.co/SwWXQ3k/ifline.jpg',
      width: 30,
      height: 30,
      alt: '*'
    }
  ],
  inputsInline: true,
  previousStatement: null,
  nextStatement: null,
  style: 'sensor_blocks',
  tooltip: '%{BKY_CUSTOM_MACHINE_IFLINE_MORTOR_IR_RESET_TOOLTIP}',
  helpUrl: ''
}

Blockly.Blocks['machine_ifline_mortor_ir_reset'] = {
  init: function () {
    this.jsonInit(blockJson)
  }
}

Blockly.Python['machine_ifline_mortor_ir_reset'] = function (block) {
  if (!block.disabled) {
    Blockly.Python.definitions_.import_ifline = 'import ifline'
    Blockly.Python.definitions_.init_ifline_mortor_ir = 'ifline.mortorIrInit()'
  }
  let code = `ifline.mortorIrReset()\n`
  return code
}
